module.exports = __webpack_public_path__ + "img/collection-engagementRingsPlatinum@2x.9704dee.webp";